import React from "react";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import CategoriesPage from "../components/Categories";


const Categories = () => {
    return (
        <div>
            <Navigation />
            <CategoriesPage />
            <Footer />
        </div>
    )
}


export default Categories;